export const Languages = {
    ar: 'ar',
    en: 'en'
}

export const LANGUAGE_CONFIG = {
    AR: 'AR',
    EN: 'EN'
}